import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import type { OperationType } from "contracts/OperationTypes";
import type { Pagination } from "contracts/Pagination";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess", "onFailure"],
    success: ["data", "pagination"],
    failure: ["errorMessage"],
    softReset: [],
    reset: [],
  },
  {
    prefix: "PAGINATE_OPERATION_TYPES_",
  }
);

export interface PaginateOperationTypesState {
  data: OperationType[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginateOperationTypesRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: OperationType[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginateOperationTypesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginateOperationTypesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: PaginateOperationTypesState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

const failure = (state: PaginateOperationTypesState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginateOperationTypesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const paginateOperationTypes = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginateOperationTypesTypes = Types;
export const PaginateOperationTypesActions = Creators;
